// extracted by css-extract-rspack-plugin
export default {"label":"B3dzH","description":"DMqiD","error":"J4K_l"};